import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';

import './scorecardRulesHeaderTable.scss';
import { ColumnData } from '../../utils/types';

type ScorecardRulesHeaderTableProps = {
    data: ColumnData[];
}

export const ScorecardRulesHeaderTable = ( {data}:ScorecardRulesHeaderTableProps) => {

    return (
        <DataTable
            value={data}
            scrollable
            scrollHeight="400px"
            responsiveLayout="scroll"
            className="dataTableScorecardRulesHeader mt-4"
        >
            <Column field="column_name" />
            <Column field="column_value" />
        </DataTable>
    );
};
